import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { ShowtimePickerContextInstance } from '../types/context';
import { ShowtimePickerSite } from './site';
const b = bemClassBuilder('v-showtime-picker-site-list');
export const ShowtimePickerSiteList = observer(props => {
    const { showtimes } = props;
    const { siteIds } = useContext(ShowtimePickerContextInstance);
    const { filmId } = useFilmContext();
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: siteIds.map(siteId => (_jsx("li", Object.assign({ className: b.element('item') }, { children: _jsx(ShowtimePickerSite, { siteId: siteId, showtimes: showtimes.filter(showtime => showtime.siteId === siteId), filmId: filmId }) }), siteId))) })));
});
ShowtimePickerSiteList.displayName = 'ShowtimePickerSiteList';
